import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ContactsBookRegular from './contacts-book-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ContactsBookRegular {...validProps} />;
}

SvgComponent.iconName = 'contactsBookRegular';

export const ContactsBookRegularIcon = svgIconWrapper(SvgComponent);
